/*
 * @Descripttion:
 * @version:
 * @Author: sujun
 * @email: 1373842098@qq.com
 * @Date: 2022-01-13 09:24:52
 * @LastEditors: K
 * @LastEditTime: 2022-09-22 11:19:27
 */

import { ADMIN_API_PREFIX, API_PREFIX } from './constant'
import { Request } from './request'

export interface ReplaceMakeSupplierParams {
  size?: number
  current?: number
  platformName?: string
  decoctionType?: number
  name?: string
  status?: number
  openType?: number
}
//  代煎供应商列表列表
export const ReplaceMakeSupplierList = (
  params: ReplaceMakeSupplierParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/list`,
    method: 'GET',
    params,
  }
}

export interface addReplaceMakeSupplierParams {
  appKey?: string
  secretKey?: string
  name?: string
  decoctionType?: string //代煎类别
  machiningType?: string //加工方式
  id?: number
  status?: number
}
//  修改新增代煎供应商
export const addReplaceMakeSupplier = (
  body: addReplaceMakeSupplierParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/submit`,
    method: 'POST',
    body,
  }
}

// 代煎设置回显
export const setReplaceMakeSupplier = (id: string): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/detail`,
    method: 'GET',
    params: {
      id,
    },
  }
}

//   开启/禁用代煎供应商
export const openReplaceMakeSupplier = (id: string): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/cancel`,
    method: 'POST',
    params: {
      id,
    },
  }
}

// 加工方式、代煎类型
export const machiningType = (): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potiondict/list`,
    method: 'GET',
  }
}

// 合作机构
export interface SupplierPartnerParams {
  size: number
  current: any
  keyWord?: string
  id: string
  status?: number
}
//  代煎供应商合作机构列表
export const SupplierPartnerList = (params: SupplierPartnerParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/getPartnersList`,
    method: 'GET',
    params,
  }
}



export interface ChangeSupplierPartnerParams {
  id: string
  status: number
}
//  修改合作机构的绑定状态
export const changeSupplierPartner = (
  body: ChangeSupplierPartnerParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/updatePartnersStatus`,
    method: 'POST',
    body,
  }
}

export interface OrganizationNameParams {
  size: 10
  current: 1
  keyWord?: string
  supplierId?: string
}
// 新增/修改合作机构的模糊查询
export const organizationName = (params: OrganizationNameParams): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/potionOpenTenantList`,
    method: 'GET',
    params,
  }
}

// 新增/修改合作机构的代煎类别
export const addEditType = (params: {
  tenantId?: number | string
  id?: string | number
}): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/getProcessingMode`,
    method: 'GET',
    params,
  }
}

// 新增合作机构
export interface AddEditSupplierPartnerParams {
  tenantId: string
  supplierId: string
  platformId: string
  tenant?: string
  hospitalNumber?: string
  organCode?: string
  account?: string
  password?: string
  decoctionType: string
  machiningType: string
  receivingType: string
  specifications?: string
  remark?: string
}
export const addEditSupplierPartner = (
  body: AddEditSupplierPartnerParams
): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/potionBindingSave`,
    method: 'POST',
    body,
  }
}

// 合作机构回显
export const showSupplierPartner = (id?: string): Request => {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/getPotionOpenTenantDetails`,
    method: 'GET',
    params: {
      id,
    },
  }
}


export interface isChangeReplaceMakeParams {
  decoctionType?: number
  machiningType?: number
  supplierId?: string
}

// 判断是否可删除
export function ChangeReplaceMake(params: isChangeReplaceMakeParams): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/getProcessingModeIfUse`,
    method: 'GET',
    params,
  }
}

// 代煎供应商列表
export function getPotionPlace(): Request {
  return {
    url: `${ADMIN_API_PREFIX}/blade-administer/m/potionsupplier/getPotionPlace`,
    method: 'GET',
  }
}
// 代煎药材目录列表
export interface getGoodsListFnParams {
  current?: number
  size?: number
  supplierId?: string
  tenantId?: string
  name?: string
}
export function getGoodsListFn(params: getGoodsListFnParams): Request {
  return {
    url: params.tenantId
      ? `${API_PREFIX}/blade-potion/drugsupplier/commonList`
      : `${API_PREFIX}/blade-potion/drugsupplier/list`,
    method: 'GET',
    params,
  }
}

// 代煎药材目录
export interface getHerbsListFnParams {
  current?: number
  size?: number
  name?: string
}
export function getHerbsListFn(params: getHerbsListFnParams): Request {
  return {
    url: `${API_PREFIX}/blade-potion/drugmap/list`,
    method: 'GET',
    params,
  }
}
// 代煎药材目录-新增 or 编辑
export interface getAddHerbsListFnParams {
  id?: number
  potionDrugName?: number
  tenantDrugName?: string
}
export function getAddHerbsListFn(body: getAddHerbsListFnParams): Request {
  return {
    url: `${API_PREFIX}/blade-potion/drugmap/submit`,
    method: 'POST',
    body,
  }
}

// 代煎药材目录-删除
export interface getDeleteHerbsListFnParams {
  id?: number
  
}
export function getDeleteHerbsListFn(body: getDeleteHerbsListFnParams): Request {
  return {
    url: `${API_PREFIX}/blade-potion/drugmap/remove`,
    method: 'POST',
    body,
  }
}